module.exports = __webpack_public_path__ + "static/ecounicorntoy-d49d0a408fa2045bd1dd0108948cf6d0.jpeg";